import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "team-nav-list",
  class: "col-12 col-md-3"
}
const _hoisted_2 = {
  class: "nav flex-column nav-pills h-100",
  role: "tablist",
  "aria-orientation": "vertical"
}
const _hoisted_3 = { class: "col-12 col-md-9 h-100 tab-content" }
const _hoisted_4 = {
  class: "tab-pane fade show active",
  id: "team-prop-general",
  role: "tabpanel"
}
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = {
  class: "tab-pane fade",
  id: "team-prop-advanced",
  role: "tabpanel"
}
const _hoisted_8 = {
  class: "tab-pane fade",
  id: "team-prop-budget",
  role: "tabpanel"
}
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "dropdown" }
const _hoisted_11 = {
  class: "btn btn-secondary dropdown-toggle",
  type: "button",
  id: "team-prop-budget-billing",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_12 = {
  class: "dropdown-menu",
  "aria-labelledby": "team-prop-budget-billing"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = {
  class: "help-text",
  id: "team-prop-budget-charges"
}
const _hoisted_16 = {
  class: "h-100 tab-pane fade",
  id: "team-prop-load",
  role: "tabpanel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BtnSubmit = _resolveComponent("BtnSubmit")!
  const _component_CapacityHeatmap = _resolveComponent("CapacityHeatmap")!

  return (_openBlock(), _createElementBlock("div", {
    class: "row h-100",
    onKeydown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.teamPropsApplyShortcut && _ctx.teamPropsApplyShortcut(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("a", {
          class: "nav-link active",
          id: "team-prop-general-tab",
          "data-toggle": "pill",
          href: "#team-prop-general",
          role: "tab",
          "aria-selected": "true"
        }, "General", -1)),
        _cache[7] || (_cache[7] = _createElementVNode("a", {
          class: "nav-link",
          id: "team-prop-advanced-tab",
          "data-toggle": "pill",
          href: "#team-prop-advanced",
          role: "tab",
          "aria-selected": "false"
        }, "Advanced", -1)),
        _cache[8] || (_cache[8] = _createElementVNode("a", {
          class: "nav-link",
          id: "team-prop-budget-tab",
          "data-toggle": "pill",
          href: "#team-prop-budget",
          role: "tab",
          "aria-selected": "false"
        }, "Budget", -1)),
        _createElementVNode("a", {
          class: "nav-link position-relative",
          id: "team-prop-load-tab",
          "data-toggle": "pill",
          href: "#team-prop-load",
          role: "tab",
          "aria-selected": "false",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateLoadsGraph && _ctx.updateLoadsGraph(...args)))
        }, [...(_cache[5] || (_cache[5] = [
          _createTextVNode("Resource Heatmap", -1),
          _createElementVNode("span", { class: "badge badge-danger badge-new" }, "New", -1)
        ]))]),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex-fill" }, null, -1)),
        _createVNode(_component_BtnSubmit, {
          title: "Apply",
          spinner: "",
          ref: "submitButton",
          submitHandler: _ctx.updateTeam,
          class: "mt-5"
        }, null, 8, ["submitHandler"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[10] || (_cache[10] = _createElementVNode("label", { for: "modal-upd-team-name" }, "Name", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "modal-upd-team-name",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.updTeamName) = $event))
          }, null, 512), [
            [_vModelText, _ctx.updTeamName]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[11] || (_cache[11] = _createElementVNode("label", { for: "modal-upd-team-desc" }, "Description", -1)),
          _withDirectives(_createElementVNode("textarea", {
            class: "form-control",
            id: "modal-upd-team-desc",
            rows: "3",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.updTeamDesc) = $event))
          }, null, 512), [
            [_vModelText, _ctx.updTeamDesc]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "subhead text-danger" }, "Delete team", -1)),
        _createElementVNode("p", null, [
          _createElementVNode("button", {
            tabindex: "-1",
            type: "button",
            class: "btn btn-sm btn-outline-danger float-right",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.removeTeam && _ctx.removeTeam(...args)))
          }, "Remove team"),
          _cache[12] || (_cache[12] = _createTextVNode(" Team will be deleted with all its projects and membership records. ", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { for: "team-prop-budget-billing" }, "Billing Account", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", _hoisted_11, _toDisplayString((_ctx.selectedBilling ? _ctx.selectedBilling.name : undefined) || 'Choose'), 1),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billingAccounts, (billing) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: "dropdown-item",
                  href: "#",
                  onClick: ($event: any) => (_ctx.selectBilling(billing))
                }, _toDisplayString(billing.name), 9, _hoisted_13))
              }), 256))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[15] || (_cache[15] = _createElementVNode("label", { for: "team-prop-budget-charges" }, "Charges", -1)),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.budget.charges) + " credits ", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_CapacityHeatmap, { ref: "capacityHeatmap" }, null, 512)
      ])
    ])
  ], 32))
}